import React from "react";
import { commonMessages } from "@temp/intl";
import { FormattedMessage } from "react-intl";
import * as S from "./styles";
export var EmptyCart = function EmptyCart() {
  return React.createElement(S.Message, null, React.createElement(FormattedMessage, commonMessages.emptyCart));
};
EmptyCart.displayName = "EmptyCart";
export default EmptyCart;